import { useMemo, useState } from "react"

import { useNavigate } from "react-router-dom"

import { PoliciesListType } from "@common-shared/config/oneVerify/oneVerifyPolicies.config.ts"
import { IOneVerifyCoverageCheckHistory } from "@common-shared/types/responseData/oneVerifyResponseData.types.ts"

import { GENERAL_CONFIG } from "../config/general.config.ts"
import { POLICIES_CONFIG } from "../config/policies.config.tsx"
import { PoliciesHelper } from "../helpers/policies.helper.ts"
import { PoliciesListHelper } from "../helpers/policiesList.helper.ts"
import { useAppSelector } from "../store/selectors/app.selector.ts"
import { policiesSelector } from "../store/selectors/policies.selector.ts"

export const useSinglePolicyViewNavigation = (listType: PoliciesListType) => {
    const navigate = useNavigate()

    const policiesState = useAppSelector(policiesSelector)

    //////// LOCAL STATES

    const [tasksListTypeNeedsReload, setTasksListTypeNeedsReload] =
        useState<boolean>(false)

    //////// MEMOs

    const { policyItems: listItems } = useMemo(() => {
        return PoliciesListHelper.getViewTypedStateData(listType, policiesState)
    }, [listType])

    // METHODS

    const onGoBack = () => {
        // If already loaded needed items
        const ignoreListReload =
            !!listItems.length &&
            (!tasksListTypeNeedsReload ||
                !POLICIES_CONFIG.tasksListTypes.includes(listType))

        navigate(
            PoliciesListHelper.getPoliciesListBaseUrl(listType) +
                (ignoreListReload
                    ? `?${GENERAL_CONFIG.urlSearchParamsKeys.ignoreListReload}=true`
                    : ""),
        )
    }

    // Navigate to new policy request ID
    const navigateToPolicyByRequestId = (
        nirvanaRequestId: string,
        withPoliciesListReload = true,
        isSmartScanResult = false,
    ) => {
        let neededUrl = PoliciesHelper.getSinglePolicyBaseUrl(listType).replace(
            ":nirvanaRequestId",
            nirvanaRequestId,
        )

        const urlSearchParts: string[] = []

        if (withPoliciesListReload) {
            urlSearchParts.push(
                `${GENERAL_CONFIG.urlSearchParamsKeys.reloadPoliciesList}=true`,
            )
        }

        if (isSmartScanResult) {
            urlSearchParts.push(
                `${GENERAL_CONFIG.urlSearchParamsKeys.isSmartScanResult}=true`,
            )
        }

        if (urlSearchParts.length) {
            neededUrl += `?${urlSearchParts.join("&")}`
        }

        navigate(neededUrl)
    }

    const onSmartScanSuccessRedirect = (
        result: IOneVerifyCoverageCheckHistory,
    ) => {
        if (result.coverageResult.requestId) {
            navigateToPolicyByRequestId(
                result.coverageResult.requestId,
                true,
                true,
            )
        }
    }

    return {
        // SETTERS
        setTasksListTypeNeedsReload,
        // METHODS
        onGoBack,
        navigateToPolicyByRequestId,
        onSmartScanSuccessRedirect,
    }
}
